import React from 'react';
import classes from 'classnames';
import classNames from './LoginForm.module.scss';
import { FormikHelpers, useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import { ConfirmForgotPasswordProps } from '@/types/login';
import AppInput from '../AppInput/AppInput';
import TheButton from '../TheButton/TheButton';
import AppLoaderCircle from '../AppLoaderCircle';

const classCode = ({ emitSubmit, styles, loading }: ConfirmForgotPasswordProps) => {
  const { t } = useTranslation();

  const LoginSchema = Yup.object().shape({
    code: Yup.string().required(t('validation.code_required').toString()),
  });

  const formik = useFormik({
    initialValues: {
      code: '',
    },
    validationSchema: LoginSchema,
    onSubmit: (emitSubmit ?? (() => {})) as (
      values: { code: string },
      formikHelpers: FormikHelpers<{ code: string }>
    ) => void,
  });

  const onClear = (event: React.MouseEvent<SVGElement, MouseEvent>, name: string) => {
    formik.setFieldValue(name, '');
  };

  return (
    <>
      <form className={classNames.classCodeForm} onSubmit={formik.handleSubmit}>
        <AppInput
          className={classes(styles.formField, {
            [styles.formFieldError]: !!formik.errors.code,
          })}
          inputWrapperClassName={classes(styles.appInputWrapper, {
            [styles.appInputWrapperError]: !!formik.errors.code,
          })}
          id='code'
          name='code'
          label={t('classCode') ?? ''}
          maxLength={12}
          type='text'
          placeholder={t('classCode') ?? ''}
          value={formik.values?.code?.trim()}
          error={t(formik.errors.code as string)}
          allowClear={true}
          emitChange={formik.handleChange}
          emitBlur={formik.handleBlur}
          emitClear={onClear}
        />

        {!loading && (
          <TheButton
            type='submit'
            disabled={formik.isSubmitting || !formik.isValid}
            className={styles.submit}
            text={t('next')}
            shouldRecolor={false}
          />
        )}
        {loading && (
          <div className={styles.loadingWrapper}>
            <AppLoaderCircle />
          </div>
        )}
      </form>
    </>
  );
};

export default classCode;
